import React from 'react';
import PropTypes from 'prop-types';
import BaseTabs from '@mui/material/Tabs';
import BaseTab from '@mui/material/Tab';
import { ifProp, prop, theme } from 'styled-tools';
import styled, { css } from 'styled-components';

function a11yProps(id, index) {
  return {
    id: `${id}-tab-${index}`,
    'aria-controls': `${id}-tabpanel-${index}`,
  };
}

const StyledTabs = styled(BaseTabs)`
  ${ifProp(
    '$controlBar',
    css`
      margin-bottom: -1px;
    `
  )}

  ${ifProp(
    '$height',
    css`
      height: ${prop('$height')};
      min-height: ${prop('$height')};
    `
  )}

  ${({ theme }) => css`
    ${theme.breakpoints.down('md')} {
      width: 100%;
    }
  `}

  .MuiTabs-indicator {
    background-color: ${prop('theme.colors.ttRed')};
  }
`;

export const Tab = styled(BaseTab)`
  font-size: 0.875rem;
  min-width: auto;
  padding: 0.75rem 1.875rem;
  font-family: ${theme('typography.fontFamilySecondary')};

  ${ifProp(
    '$height',
    css`
      height: ${prop('$height')};
      min-height: ${prop('$height')};
    `
  )}

  ${ifProp(
    '$disabled',
    css`
      opacity: 0.3;
    `
  )}

  &&& {
    &.Mui-disabled {
      cursor: default;
      opacity: 0.3;
    }

    &.Mui-selected {
      color: ${theme('colors.black')};
      opacity: 1;
      font-weight: 700;
    }
  }
`;

function Tabs({
  tabs,
  id,
  controlBar = false,
  disabled,
  height,
  scrollButtons = 'off',
  variant,
  ...props
}) {
  return (
    <StyledTabs
      id={`${id}-tabs`}
      $controlBar={controlBar}
      $height={height}
      scrollButtons={scrollButtons}
      variant={variant}
      {...props}
    >
      {tabs.map((tab, i) => (
        <Tab
          disabled={tab.disabled}
          key={i}
          label={tab.label}
          $height={height}
          tabIndex={0}
          {...a11yProps(tab.id, i)}
        />
      ))}
    </StyledTabs>
  );
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      disabled: PropTypes.bool,
      id: PropTypes.string
    })
  ).isRequired,
  id: PropTypes.string.isRequired,
  controlBar: PropTypes.bool,
  height: PropTypes.string,
  scrollButtons: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  variant: PropTypes.string,
};

export default Tabs;
